import { InboundReceiptStatus } from '@typings/entities/InboundReceipt'
import { t } from '@lingui/macro'
import { FlagAppearanceType } from '@constants/FlagAppearance'

export const inboundReceiptStatusTrans: Record<InboundReceiptStatus, () => string> = {
  new: () => t({ id: `inboundReceiptStatus.new`, message: `new` }),
  processed: () => t({ id: `inboundReceiptStatus.processed`, message: `processed` }),
  failed: () => t({ id: `inboundReceiptStatus.failed`, message: `failed` }),
}

export const inboundReceiptStatusToColor: Record<InboundReceiptStatus, FlagAppearanceType> = {
  new: 'blueSubtle',
  processed: 'orangeSubtle',
  failed: 'redBold',
}
